function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

module.exports = _interopRequireDefault;


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/utils/~/@babel/runtime/helpers/interopRequireDefault.js
// module id = 378
// module chunks = 0